






















import api from '@/lib/api'
import { Resource } from '@/lib/types'
import Box from '@/components/ui/Box.vue'
import Vue from 'vue'
export default Vue.extend({
    components: { Box },
    props: {
        ticket: String,
        tag: String,
        pipe: Array
    },
    data(){
        return {
            boxes: [] as Resource[],
            next: '',
            stopped: false
        }
    },
    watch: {
        pipe(curr, _){
            const item = curr[0]
            console.log(item.event, item.id);
            
            if(item.event === 'delete'){
                this.boxes = this.boxes.filter(box => box.id !== item.id);
            }
            
        }
    },
    methods: {
        propagateClick(index: number){
            this.$emit('resource', this.boxes[index]);
        },
        propagateDeletion(id: number){
            this.boxes = this.boxes.filter(box => box.id !== id);
            this.$emit('globalDeletion', id);
        },
        async fetchResources(){
            if(this.stopped) return;
            
            if(this.$props.ticket){
                const res = await api.media.resources.getByTicket(this.$props.ticket, this.next);
                if(res.err) return alert("di' a cippi che è successo un casino")
                res.ok!.value.resources.forEach(p => this.boxes.push(p));
                this.next = res.ok!.value.next;
                if(this.next === null) this.stopped = true;
            }else if(this.$props.tag){               
                const res = await api.media.resources.getByTag(this.$props.tag, this.next);
                if(res.err) return alert("di' a cippi che è successo un casino")
                res.ok!.value.resources.forEach(p => this.boxes.push(p));
                this.next = res.ok!.value.next;
                if(this.next === null) this.stopped = true;
            }

        }
    },
    async mounted(){
        if(this.$props.ticket || this.$props.tag){
            if(!('IntersectionObserver' in window)){
                await this.fetchResources();
            }
            else{

                const observer = new IntersectionObserver(async(e) => {

                    if(e[0].intersectionRatio <= 0) return;
                    console.log("intersected");
                    
                    await this.fetchResources();
                    observer.unobserve(this.$el);

                })

                observer.observe(this.$el);

            }

            this.$el.querySelector('.flexbox')?.addEventListener('scroll', async(e) => {
                const el = (e.target as HTMLElement);
                const width = el.clientWidth,
                    scroll_width = el.scrollWidth,
                    scroll_left = el.scrollLeft;
                if (scroll_width - width === scroll_left){
                    await this.fetchResources();
                }
            })
        }
    }
})
